<template>
	<bernstein-layout>
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="variations.prev_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="variations.prev_page_url"
				>Previous Page
			</Link>
			<Link
				v-if="variations.next_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="variations.next_page_url"
				>Next Page
			</Link>
		</div>
		<!-- {{variations.data}} -->
		<!-- <pagination class="mt-10" :links="variations.links" /> -->
		<!-- {{variations.next_page_url}} -->
		<div class="flex flex-col overscroll-x-contain">
			<!-- <div class="flex-grow overflow-auto"> -->
			<Table
				:filters="queryBuilderProps.filters"
				:search="queryBuilderProps.search"
				:columns="queryBuilderProps.columns"
				:on-update="setQueryBuilder"
				:meta="variations"
				class="relative w-full border"
			>
				<template #head>
					<tr
						class="sticky border-b border-gray-400 bg-gray-300 py-2 font-bold text-gray-900"
					>
						<!-- <th @click.prevent="sortBy('name')">Stock Id</th> -->
						<!-- <td v-show="showColumn('manufacturerId')">S.N.</td> -->
						<!-- <th class="sticky top-0 border-r border-green-200" v-show="showColumn('updatedAt')" @click.prevent="sortBy('updatedAt')">UpdatedAt</th> -->
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('manufacturerId')"
							@click.prevent="sortBy('manufacturerId')"
						>
							Manufacturer
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('itemId')"
							@click.prevent="sortBy('itemId')"
						>
							itemId
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('variation_id')"
							@click.prevent="sortBy('variationId')"
						>
							variationId
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('imageId')"
						>
							Image
						</th>
						<!-- // here is the article name -->
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('article')"
							@click.prevent="sortBy('number')"
						>
							Article
						</th>
						<!-- keyword  -->
						<!-- <th class="sticky top-0 border-r border-green-200"  v-show="showColumn('item.keywords')" >Keywords</th>       -->

						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('availability')"
							@click.prevent="sortBy('availability')"
						>
							Availability
						</th>

						<!-- kommentare schreiben  -->
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('purchasePrice')"
						>
							Comments
						</th>

						<!-- Here is purchase price  -->
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('purchasePrice')"
							@click.prevent="sortBy('purchasePrice')"
						>
							Purchase Price (EK USD)
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('purchasePrice')"
							@click.prevent="sortBy('purchasePrice')"
						>
							Purchase Price (EUR)
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('purchasePrice')"
							@click.prevent="sortBy('purchasePrice')"
						>
							Selling Price(EUR)
						</th>
						<!-- // -->
						<th
							class="sticky top-0"
							v-show="showColumn('total_stock_physical')"
						>
							Total stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('total_stock_net')"
						>
							stockNet
						</th>
						<!-- // -->
						<!-- Verkauf Statistics  -->
						<th class="sticky top-0" v-show="showColumn('verkauf_statistik')">
							Durchnitlicher Verkauf pro Tag
						</th>
						<th class="sticky top-0" v-show="showColumn('verkauf_statistik')">
							pro Woche
						</th>
						<th class="sticky top-0" v-show="showColumn('verkauf_statistik')">
							pro Monat
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('verkauf_statistik')"
						>
							pro Jahr
						</th>
						<!-- Stock based on lager    -->
						<th class="sticky top-0" v-show="showColumn('warehosue_keramag')">
							Keramag stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_keramag')"
						>
							stockNet
						</th>
						<!-- // -->
						<th class="sticky top-0" v-show="showColumn('warehosue_hochheim')">
							Hochheim stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_hochheim')"
						>
							stockNet
						</th>
						<!-- // -->
						<th
							class="sticky top-0"
							v-show="showColumn('warehosue_floersheim')"
						>
							Flörsheim stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_floersheim')"
						>
							stockNet
						</th>
						<!-- // -->
						<th
							class="sticky top-0"
							v-show="showColumn('warehosue_schulzbach')"
						>
							Sulzbach stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_schulzbach')"
						>
							stockNet
						</th>
						<!-- // -->
						<!-- // -->
						<th
							class="sticky top-0"
							v-show="showColumn('warehosue_vormontage')"
						>
							Vormontage stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_vormontage')"
						>
							stockNet
						</th>
						<!-- // -->
						<th class="sticky top-0" v-show="showColumn('warehosue_lkw')">
							LKW stockPhysical
						</th>
						<th
							class="sticky top-0 border-r border-green-200"
							v-show="showColumn('warehosue_lkw')"
						>
							stockNet
						</th>

						<!-- <th v-show="showColumn('stock_physical')" @click.prevent="sortBy('stockPhysical')">stockPhysical</th> -->
						<!-- <th v-show="showColumn('stock_net')" @click.prevent="sortBy('stockNet')">stockNet</th> -->
					</tr>
					<!-- <tr><th class="fixed top-0"> test</th> </tr>      -->
				</template>

				<template #body>
					<tr
						v-for="(variation, variationIndx) in variations.data"
						:key="variationIndx"
						:class="[{ 'bg-gray-100': variationIndx % 2 == 0 }, p - 1]"
					>
						<!-- <td>{{ variation.itemId }}</td> -->
						<!-- <td v-show="showColumn('manufacturerId')">{{ variation.id }}</td> -->
						<!-- <td class="border-r border-green-200" v-show="showColumn('updatedAt')">{{ variation.updatedAt}}</td> -->

						<td
							class="border-r border-green-200"
							v-show="showColumn('manufacturerId')"
						>
							{{ variation.manufacturer.name }}
						</td>
						<td class="border-r border-green-200" v-show="showColumn('itemId')">
							{{ variation.itemId }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('variation_id')"
						>
							{{ variation.variationId }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('imageId')"
						>
							<img
								v-if="variation.image[0]"
								:src="variation.image[0].urlPreview"
								@click="openModal(variation.image[0])"
								class="max-w-20 max-h-20 object-fill"
							/>
						</td>
						<!-- v-on:mouseover = "openModal(stock.image[0])" -->
						<!-- // Article -->
						<td
							class="w-16 border-r border-green-200"
							v-show="showColumn('article')"
						>
							{{ articleName(variation.number) }}
						</td>
						<!-- keywords  -->
						<!-- <td  class="border-r border-green-200 w-16" v-show="showColumn('item.keywords')"> 
            <span v-if="variation.item"> {{getKeyword(variation.item)}} </span></td> 
           -->

						<td
							class="border-r border-green-200"
							v-show="showColumn('availability')"
						>
							{{ variation.availability }}
						</td>
						<!-- kommentare  -->
						<td
							class="border-r border-green-200"
							v-show="showColumn('purchasePrice')"
						>
							Kommentare
						</td>

						<!-- ek usd  -->
						<td
							class="border-r border-green-200"
							v-show="showColumn('purchasePrice')"
						>
							{{ variation.purchasePrice }}
						</td>

						<td
							class="border-r border-green-200"
							v-show="showColumn('purchasePrice')"
						>
							{{ variation.purchasePrice }}
						</td>
						<!-- verkauf preis    -->
						<td
							class="border-r border-green-200"
							v-show="showColumn('purchasePrice')"
						>
							Verkauf preis
						</td>
						<!-- // -->
						<td v-show="showColumn('total_stock_physical')">
							{{ totalStockPhysical(variation.stocks) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('total_stock_net')"
						>
							{{ totalStockNet(variation.stocks) }}
						</td>
						<!-- Verkauf Statistics  -->
						<td
							class="border-green-200"
							v-show="showColumn('verkauf_statistik')"
						>
							{{ verkauf_statistik_pro_tag(variation.orderitems) }}
						</td>
						<td
							class="border-green-200"
							v-show="showColumn('verkauf_statistik')"
						>
							{{ verkauf_statistik_pro_woche(variation.orderitems) }}
						</td>
						<td
							class="border-green-200"
							v-show="showColumn('verkauf_statistik')"
						>
							{{ verkauf_statistik_pro_monat(variation.orderitems) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('verkauf_statistik')"
						>
							{{ verkauf_statistik_pro_jahr(variation.orderitems) }}
						</td>

						<!-- /Lager stock / -->
						<td v-show="showColumn('warehosue_keramag')">
							{{ stockPhysical(variation.stocks, 25) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_keramag')"
						>
							{{ stockNet(variation.stocks, 25) }}
						</td>
						<!-- // -->
						<td v-show="showColumn('warehosue_hochheim')">
							{{ stockPhysical(variation.stocks, 17) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_hochheim')"
						>
							{{ stockNet(variation.stocks, 17) }}
						</td>
						<!-- // -->

						<td v-show="showColumn('warehosue_floersheim')">
							{{ stockPhysical(variation.stocks, 4) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_floersheim')"
						>
							{{ stockNet(variation.stocks, 4) }}
						</td>
						<!-- // -->
						<td v-show="showColumn('warehosue_schulzbach')">
							{{ stockPhysical(variation.stocks, 3) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_schulzbach')"
						>
							{{ stockNet(variation.stocks, 3) }}
						</td>
						<!-- // -->
						<td v-show="showColumn('warehosue_vormontage')">
							{{ stockPhysical(variation.stocks, 8) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_vormontage')"
						>
							{{ stockNet(variation.stocks, 8) }}
						</td>
						<!-- // -->
						<td v-show="showColumn('warehosue_lkw')">
							{{ stockPhysical(variation.stocks, 19) }}
						</td>
						<td
							class="border-r border-green-200"
							v-show="showColumn('warehosue_lkw')"
						>
							{{ stockNet(variation.stocks, 19) }}
						</td>

						<!-- <td v-show="showColumn('stock_physical')">{{ variation.stockPhysical }}</td> -->
						<!-- <td v-show="showColumn('stock_net')">{{ variation.stockNet }}</td> -->
					</tr>
				</template>
			</Table>
		</div>
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="variations.prev_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="variations.prev_page_url"
				>Previous Page
			</Link>
			<Link
				v-if="variations.next_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="variations.next_page_url"
				>Next Page
			</Link>
		</div>
		<!-- </div> -->
		<!-- here starts the modal  -->
		<TransitionRoot appear :show="isOpen" as="template">
			<Dialog as="div" @close="closeModal">
				<div class="fixed inset-0 z-10 overflow-y-auto">
					<div class="min-h-screen px-4 text-center">
						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0"
							enter-to="opacity-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100"
							leave-to="opacity-0"
						>
							<DialogOverlay class="fixed inset-0" />
						</TransitionChild>

						<span class="inline-block h-screen align-middle" aria-hidden="true">
							&#8203;
						</span>

						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0 scale-95"
							enter-to="opacity-100 scale-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100 scale-100"
							leave-to="opacity-0 scale-95"
						>
							<div
								class="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-gray-50 bg-white p-6 text-left align-middle shadow-xl transition-all"
							>
								<!-- <DialogTitle
                    as="h3"
                    class="text-lg font-medium leading-6 text-gray-900"
                  >
                    Payment successful
                  </DialogTitle> -->
								<!-- <div class="mt-2"> -->
								<!-- <div class="text-sm text-gray-500">
                      Your payment has been successfully submitted. We’ve sent you
                      an email with all of the details of your order.
                      
                    </div> -->

								<img :src="picUrl" class="h-full w-full object-cover" />

								<!-- </div> -->

								<div class="mt-4 mr-0 text-right">
									<button
										type="button"
										class="justify-right inline-flex rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
										@click="closeModal"
									>
										Schließen
									</button>
								</div>
							</div>
						</TransitionChild>
					</div>
				</div>
			</Dialog>
		</TransitionRoot>
		<!-- here ends the modal  -->

		<!-- Here ends the content  -->
		<!-- {{variations}}  -->
	</bernstein-layout>
</template>
<script>
/***
 * import
 */
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";
import { ref } from "vue";
/***
 * export
 */
export default {
	mixins: [InteractsWithQueryBuilder],
	components: {
		BernsteinLayout,
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
	},

	props: {
		variations: Array,
	},

	computed: {
		// stockPhysical(stock){
		//   return  stock.stockPhysical;
		// }
	},
	setup() {
		const isOpen = ref(false);
		const picUrl = ref("");

		return {
			isOpen,
			picUrl,
			closeModal() {
				isOpen.value = false;
			},
			openModal(image) {
				isOpen.value = true;
				// console.log("test");
				// console.log(image.url);
				if (image.url != "") {
					picUrl.value = image.url;
				}
				// console.log(picUrl);
			},
		};
	},
	data() {
		return {
			// Calculate milliseconds in a year
		};
	},
	methods: {
		/**
		 *
		 * Get key words .
		 *@params: array
		 *@return: strign
		 **/
		getKeyword: function (item) {
			//  console.log(item);
			// console.log(item.keywords);
			let k_w = "";
			if (item) {
				k_w = item.keywords;
				if (k_w != "") {
					let _my_arr = k_w.split(",");
					//  console.log(_my_arr);
					if (_my_arr.length == 1) {
						return _my_arr[0];
					}
					if (_my_arr.length > 1) {
						return _my_arr[0] + ", " + _my_arr[1];
					}
				}
				return k_w;
			}
			return k_w;
		},

		/**
		 *
		 */
		changeImageWhen: function (imageArray, state) {
			if (state == "over") {
				this.hovered = true;
				return imageArray.url;
			}
			if (state == "down") {
				this.hovered = false;
				return imageArray.urlPreview;
			}
		},
		//gesammt stock net
		totalStockNet: function (stockArray) {
			//  stockArray
			let gesammt = stockArray.reduce(function (summe, current) {
				return summe + current.stockNet;
			}, 0);
			return gesammt;
		},
		/**
		 * gesammt stock Physical
		 */
		totalStockPhysical: function (stockArray) {
			//  stockArray
			let gesammt = stockArray.reduce(function (summe, current) {
				return summe + current.stockPhysical;
			}, 0);
			return gesammt;
		},

		stockPhysical: function (stockArray, warehouseNr) {
			// let stock ={};
			let stock = stockArray.find(
				(element) => element.warehouseId == warehouseNr
			);
			if (stock) {
				return stock.stockPhysical;
			} else {
				return 0;
			}
			//  console.log(typeof(stock));
			//  return stock.stockPhysical;
		},
		stockNet: function (stockArray, warehouseNr) {
			// let stock ={};
			let stock = stockArray.find(
				(element) => element.warehouseId == warehouseNr
			);
			if (stock) {
				return stock.stockNet;
			} else {
				return 0;
			}
			//  console.log(typeof(stock));
			//  return stock.stockPhysical;
		},
		articleName(name) {
			return name.split("_").join(", \n");
		},
		/**
		 *
		 * sum of two numbers
		 */
		summe(a, b) {
			return a + b;
		},
		verkauf_statistik_pro_tag(orderItemArray) {
			var total_verkauf = 0;
			var start_date = 0;
			for (var i = 0; i < orderItemArray.length; i++) {
				total_verkauf += orderItemArray[i].quantity;
				if (i == 0) {
					start_date = new Date(orderItemArray[i].createdAt);
				} else {
					var start_date1 = new Date(orderItemArray[i].createdAt);
					start_date = Math.min(start_date, start_date1);
				}
			}
			// console.log(total_verkauf);
			// total_verkauf =quantity.reduce(this.summe);

			// return total_verkauf;
			if (total_verkauf === 0) {
				return 0;
			} else {
				// Calculate milliseconds in a year
				// const start_date    = new Date(2019,0,1,0,0,0,0);
				const today = new Date();
				const minute = 1000 * 60;
				const hour = minute * 60;
				const day = hour * 24;
				const month = (day * 365) / 12;
				const year = day * 365;
				let total_days = (today - start_date) / day;
				let verkauf_pro_tag = 0;
				verkauf_pro_tag = (total_verkauf / total_days).toFixed(4);
				return verkauf_pro_tag;
			}
			return 0;
		},
		// verkauf pro woch e
		verkauf_statistik_pro_woche(orderItemArray) {
			var total_verkauf = 0;
			var start_date = 0;
			for (var i = 0; i < orderItemArray.length; i++) {
				total_verkauf += orderItemArray[i].quantity;
				if (i == 0) {
					start_date = new Date(orderItemArray[i].createdAt);
				} else {
					var start_date1 = new Date(orderItemArray[i].createdAt);
					start_date = Math.min(start_date, start_date1);
				}
			}
			// return total_verkauf;
			if (total_verkauf === 0) {
				return 0;
			} else {
				// Calculate milliseconds in a year

				//  const start_date    = new Date(2019,0,1,0,0,0,0);
				const today = new Date();
				const minute = 1000 * 60;
				const hour = minute * 60;
				const day = hour * 24;
				const week = day * 7;
				const month = (day * 365) / 12;
				const year = day * 365;
				let total_weeks = (today - start_date) / week;
				let verkauf_pro_woche = 0;
				verkauf_pro_woche = (total_verkauf / total_weeks).toFixed(4);
				return verkauf_pro_woche;
			}
			return 0;
		},

		/****
		 *
		 *Verkauf pro Monat
		 *
		 */
		// verkauf pro woch e
		verkauf_statistik_pro_monat(orderItemArray) {
			var total_verkauf = 0;
			var start_date = 0;
			for (var i = 0; i < orderItemArray.length; i++) {
				total_verkauf += orderItemArray[i].quantity;
				if (i == 0) {
					start_date = new Date(orderItemArray[i].createdAt);
				} else {
					var start_date1 = new Date(orderItemArray[i].createdAt);
					start_date = Math.min(start_date, start_date1);
				}
			}
			// return total_verkauf;
			if (total_verkauf === 0) {
				return 0;
			} else {
				// Calculate milliseconds in a year
				// const start_date    = new Date(2019,0,1,0,0,0,0);
				const today = new Date();
				const minute = 1000 * 60;
				const hour = minute * 60;
				const day = hour * 24;
				const week = day * 7;
				const month = (day * 365) / 12;
				const year = day * 365;
				let total_months = (today - start_date) / month;
				let verkauf_pro_month = 0;
				verkauf_pro_month = (total_verkauf / total_months).toFixed(4);
				return verkauf_pro_month;
			}
			return 0;
		},
		/****
		 *
		 *Verkauf pro Jahr
		 *
		 */
		// verkauf pro woch e
		verkauf_statistik_pro_jahr(orderItemArray) {
			var total_verkauf = 0;
			var start_date = 0;
			for (var i = 0; i < orderItemArray.length; i++) {
				total_verkauf += orderItemArray[i].quantity;
				if (i == 0) {
					start_date = new Date(orderItemArray[i].createdAt);
				} else {
					var start_date1 = new Date(orderItemArray[i].createdAt);
					start_date = Math.min(start_date, start_date1);
				}
			}
			// return total_verkauf;
			if (total_verkauf === 0) {
				return 0;
			} else {
				// Calculate milliseconds in a year
				// const start_date    = new Date(2019,0,1,0,0,0,0);
				const today = new Date();
				const minute = 1000 * 60;
				const hour = minute * 60;
				const day = hour * 24;
				const week = day * 7;
				const month = (day * 365) / 12;
				const year = day * 365;
				let total_years = (today - start_date) / year;
				let verkauf_pro_year = 0;
				verkauf_pro_year = (total_verkauf / total_years).toFixed(4);
				return verkauf_pro_year;
			}
			return 0;
		},
	},
};
</script>
